import { TrucksPageStore } from '@pages/trucks/store/TrucksPageStore';

export const store = new TrucksPageStore();
(window as any).store = store;
